module.exports = __webpack_public_path__ + "static/shopmatic4-168b6439e753c4afe57a49c7c0a04abb.png";